import React, {useState} from "react";
import {
  AppBar,
  Box,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Badge,
  styled,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import { Mail, Notifications, Menu, QrCode2, Home, AccountCircle, ReceiptLong, SupportAgent, Settings, Reviews, Logout } from "@mui/icons-material";

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
})

export const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const drawerList = [
    {
      text: 'Home',
      icon: <Home />,
    },
    {
      text: 'Digital Ticket',
      icon: <QrCode2 />,
    },
    {
      text: 'Profile Info',
      icon: <AccountCircle />,
    },
    {
      text: 'Transaction History',
      icon: <ReceiptLong />,
    },
    {
      text: 'Help & Support',
      icon: <SupportAgent />,
    },
    {
      text: 'Settings',
      icon: <Settings />,
    },
    {
      text: 'Rate Us',
      icon: <Reviews />,
    },
    {
      text: 'Logout',
      icon: <Logout />,
    }
  ]

  return (
    <AppBar position="sticky">
      <StyledToolbar
      >
        <Box>
          <IconButton
            size="large"
            edge="start"
            color="mywhite"
            aria-label="hamburger more"
            sx={{ display: { xs: "none", sm: "inline-block" } }}
            onClick={() => {setIsDrawerOpen(true)}}
          >
            <Menu />
          </IconButton>
          <Typography variant="h5" component="span" sx={{ color: "#fff" }}>
            bukafey
          </Typography>
        </Box>
        <Drawer anchor="left" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
          <Box p={2} width='250px' role="presentation">
          <List>
        {drawerList.map((value, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton onClick={() => setIsDrawerOpen(false)}>
              <ListItemIcon>
                {value.icon}
              </ListItemIcon>
              <ListItemText primary={value.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
          </Box>
        </Drawer>
        <Box spacing={2}>
          <IconButton color="mywhite">
            <Badge badgeContent={0} color="error">
              <Mail />
            </Badge>
          </IconButton>
          <IconButton color="mywhite">
            <Badge badgeContent={4} color="error">
              <Notifications />
            </Badge>
          </IconButton>
        </Box>
      </StyledToolbar>
    </AppBar>
    
  );
};
